module.exports = __webpack_public_path__ + "media/images/profile/lifestyle-info-faaf6215d372d51948e070dc68155fb4.svg";